import React from 'react';
import { CommunicationMessage, Illustrations, IllustrationSize } from '../CommunicationMessage';

export interface EmptyErrorMessageProps {
  headline: string;
  text?: string;
  illustrationSize?: IllustrationSize;
}

export const EmptyErrorMessage: React.FC<EmptyErrorMessageProps> = ({
  headline,
  text,
  illustrationSize = IllustrationSize.Large,
}) => {
  return (
    <div className="flex flex-1 items-center justify-center">
      <CommunicationMessage
        headline={headline}
        text={text ?? ''}
        illustration={Illustrations.Empty}
        illustrationSize={illustrationSize}
      />
    </div>
  );
};
